import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M2 6.75A2.25 2.25 0 0 1 4.25 4.5h15.5A2.25 2.25 0 0 1 22 6.75v5.588a7 7 0 0 0-1.5-1.393V6.75a.75.75 0 0 0-.75-.75H4.25a.75.75 0 0 0-.75.75v10.5c0 .414.336.75.75.75h5.638a6.8 6.8 0 0 0 .49 1.5H4.25A2.25 2.25 0 0 1 2 17.25z" }, null, -1),
    _createElementVNode("path", { d: "M18.25 9.75H5.75a.75.75 0 0 1 0-1.5h12.5a.75.75 0 0 1 0 1.5M10.945 12.75a7 7 0 0 1 1.33-1.448.8.8 0 0 0-.275-.052H5.75a.75.75 0 0 0 0 1.5z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M20.657 15.282c0 1.216-.54 2.307-1.392 3.046v2.922a.75.75 0 0 1-1.256.553l-1.383-1.264-1.382 1.264a.75.75 0 0 1-1.256-.553v-2.919a4.031 4.031 0 1 1 6.668-3.05m-4.032-2.532a2.532 2.532 0 1 0 0 5.063 2.532 2.532 0 0 0 0-5.063",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }